import React from "react";
import { Icons } from "../../constants/icon-library";
import { getIcon } from "../../constants/constants";
import { getPlatformColumns } from "../../utils/platformConfigFields";
import { renderTaskFieldValue } from "../Tasks/TaskFieldRenderer";

const NON_FIELD_KEYS = new Set([
  "checkbox",
  "task",
  "platform",
  "status",
  "result",
  "failure",
  "actions",
]);

function PlatformExecuteModal({ modalState, data, handlers, isExecuting }) {
  const { show, platform, action, item, authorName } = modalState;
  const { participants, taskOptions } = data;
  const { onClose, onFieldUpdate, onExecute } = handlers;

  if (!show) return null;

  const platformType = platform?.assistantId?.platform?.type;
  const platformName = platform?.assistantId?.name;
  const iconUrl = getIcon(platformType);

  const columns = (
    getPlatformColumns({ platformType, hasResult: false, hasFailure: false }) ||
    []
  ).filter((col) => !NON_FIELD_KEYS.has(col.key));

  const isLoading = !!isExecuting;
  const canExecute = !!action;

  const update = (payload) => {
    if (!action) return;
    onFieldUpdate(action.uuid, payload);
  };

  return (
    <div
      className="modal d-block conv-modal-backdrop"
      tabIndex={-1}
      onClick={onClose}
    >
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center justify-content-between conv-modal-header">
            <h6 className="modal-title d-flex align-items-center gap-2 mb-0">
              {iconUrl ? (
                <img src={iconUrl} alt={platformName} width={18} height={18} />
              ) : (
                <i className="bi bi-plug-fill text-primary" />
              )}
              Execute on {platformName}
            </h6>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              style={{ margin: 0 }}
            />
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label small fw-semibold text-body-secondary text-uppercase conv-modal-label">
                Message
              </label>
              <div className="bg-body-secondary rounded-3 p-2 conv-modal-message-box">
                {item?.text}
              </div>
              {authorName && (
                <small className="text-body-secondary">From {authorName}</small>
              )}
            </div>

            {!action ? (
              <div className="alert alert-warning py-2" style={{ fontSize: 12 }}>
                This message must be added to tasks before it can be executed.
              </div>
            ) : columns.length === 0 ? (
              <div className="text-body-secondary" style={{ fontSize: 12 }}>
                No additional configuration available for {platformName}.
              </div>
            ) : (
              columns.map((col) => (
                <div className="mb-3" key={col.key}>
                  <label className="form-label small fw-semibold text-body-secondary text-uppercase conv-modal-label">
                    {col.label}
                  </label>
                  <div className="conv-modal-field-wrap">
                    {renderTaskFieldValue({
                      col,
                      action,
                      platformType,
                      taskOptions,
                      participants,
                      isLoading,
                      size: "modal",
                      onUpdate: update,
                    })}
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-sm btn-primary d-flex align-items-center gap-1"
              onClick={onExecute}
              disabled={!canExecute || isLoading}
              title={!canExecute ? "Add this message to tasks first" : "Execute"}
            >
              {isLoading ? (
                <span className="spinner-border spinner-border-sm" />
              ) : (
                <i className={`wb ${Icons("resume")}`} />
              )}
              Execute
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlatformExecuteModal;